// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .header-panel {
  background-color: var(--headerBackground);
  color: var(--headerColor);
  position: absolute;
  top: 0px;
  left: 0px;
  height: 36px;
  width: 100%;
  text-align: center;
  line-height: 36px;
  border-bottom: 1px solid var(--headerBorder);
}
:host .header-panel mat-icon {
  display: inline-block;
  vertical-align: text-top;
}
:host .work-panel {
  position: absolute;
  top: 37px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: var(--workPanelBackground);
}
:host .container {
  width: 100%;
  height: 100%;
}
:host .mat-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  overflow: auto;
}
:host .mat-column-select {
  overflow: visible;
  flex: 0 0 80px;
}
:host .mat-column-id {
  flex: 1 1 200px;
}
:host .mat-column-group {
  flex: 1 1 200px;
}
:host .mat-column-value {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-1, :host mat-cell.mat-column-lang-1 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-2, :host mat-cell.mat-column-lang-2 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-3, :host mat-cell.mat-column-lang-3 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-4, :host mat-cell.mat-column-lang-4 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-5, :host mat-cell.mat-column-lang-5 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-6, :host mat-cell.mat-column-lang-6 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-7, :host mat-cell.mat-column-lang-7 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-8, :host mat-cell.mat-column-lang-8 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-9, :host mat-cell.mat-column-lang-9 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-10, :host mat-cell.mat-column-lang-10 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-11, :host mat-cell.mat-column-lang-11 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-12, :host mat-cell.mat-column-lang-12 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-13, :host mat-cell.mat-column-lang-13 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-14, :host mat-cell.mat-column-lang-14 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-15, :host mat-cell.mat-column-lang-15 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-16, :host mat-cell.mat-column-lang-16 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-17, :host mat-cell.mat-column-lang-17 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-18, :host mat-cell.mat-column-lang-18 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-19, :host mat-cell.mat-column-lang-19 {
  flex: 1 1 200px;
}
:host mat-header-cell.mat-column-lang-20, :host mat-cell.mat-column-lang-20 {
  flex: 1 1 200px;
}
:host .mat-column-remove {
  flex: 1 1 60px;
  padding-right: 0px !important;
}
:host .mat-cell {
  font-size: 13px;
  overflow: visible;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
:host .mat-header-cell {
  font-size: 15px;
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/language/language-text-list/language-text-list.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/language/language-text-list/language-text-list.component.scss"],"names":[],"mappings":"AACI;EACI,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;ACAR;ADEQ;EACI,qBAAA;EACA,wBAAA;ACAZ;ADII;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,4CAAA;ACFR;ADKI;EACI,WAAA;EACA,YAAA;ACHR;ADMI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;ACJR;ADOI;EACI,iBAAA;EACA,cAAA;ACLR;ADQI;EACI,eAAA;ACNR;ADUI;EACI,eAAA;ACRR;ADWI;EACI,eAAA;ACTR;ADaQ;EACI,eAAA;ACXZ;ADUQ;EACI,eAAA;ACRZ;ADOQ;EACI,eAAA;ACLZ;ADIQ;EACI,eAAA;ACFZ;ADCQ;EACI,eAAA;ACCZ;ADFQ;EACI,eAAA;ACIZ;ADLQ;EACI,eAAA;ACOZ;ADRQ;EACI,eAAA;ACUZ;ADXQ;EACI,eAAA;ACaZ;ADdQ;EACI,eAAA;ACgBZ;ADjBQ;EACI,eAAA;ACmBZ;ADpBQ;EACI,eAAA;ACsBZ;ADvBQ;EACI,eAAA;ACyBZ;AD1BQ;EACI,eAAA;AC4BZ;AD7BQ;EACI,eAAA;AC+BZ;ADhCQ;EACI,eAAA;ACkCZ;ADnCQ;EACI,eAAA;ACqCZ;ADtCQ;EACI,eAAA;ACwCZ;ADzCQ;EACI,eAAA;AC2CZ;AD5CQ;EACI,eAAA;AC8CZ;AD1CI;EACI,cAAA;EACA,6BAAA;AC4CR;ADzCI;EACI,eAAA;EACA,iBAAA;AC2CR;ADxCI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;AC0CR;ADvCI;EACI,eAAA;EACA,iBAAA;ACyCR","sourcesContent":[":host {\n    .header-panel {\n        background-color: var(--headerBackground);\n        color: var(--headerColor);\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 36px;\n        width: 100%;\n        text-align: center;\n        line-height: 36px;\n        border-bottom: 1px solid var(--headerBorder);\n\n        mat-icon {\n            display: inline-block;\n            vertical-align: text-top;\n        }\n    }\n\n    .work-panel {\n        position: absolute;\n        top: 37px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n        background-color: var(--workPanelBackground);\n    }\n\n    .container {\n        width: 100%;\n        height: 100%;\n    }\n\n    .mat-table {\n        width: 100%;\n        height: 100%;\n        table-layout: fixed;\n        overflow: auto;\n    }\n\n    .mat-column-select {\n        overflow: visible;\n        flex: 0 0 80px;\n    }\n\n    .mat-column-id {\n        flex: 1 1 200px;\n    }\n\n\n    .mat-column-group {\n        flex: 1 1 200px;\n    }\n\n    .mat-column-value {\n        flex: 1 1 200px;\n    }\n\n    @for $i from 1 through 20 {\n        mat-header-cell.mat-column-lang-#{$i}, mat-cell.mat-column-lang-#{$i} {\n            flex: 1 1 200px;\n        }\n    }\n\n    .mat-column-remove {\n        flex: 1 1 60px;\n        padding-right: 0px !important;\n    }\n\n    .mat-cell {\n        font-size: 13px;\n        overflow: visible;\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n\n    .mat-header-cell {\n        font-size: 15px;\n        overflow: visible;\n    }\n\n}\n",":host .header-panel {\n  background-color: var(--headerBackground);\n  color: var(--headerColor);\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 36px;\n  width: 100%;\n  text-align: center;\n  line-height: 36px;\n  border-bottom: 1px solid var(--headerBorder);\n}\n:host .header-panel mat-icon {\n  display: inline-block;\n  vertical-align: text-top;\n}\n:host .work-panel {\n  position: absolute;\n  top: 37px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: var(--workPanelBackground);\n}\n:host .container {\n  width: 100%;\n  height: 100%;\n}\n:host .mat-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  overflow: auto;\n}\n:host .mat-column-select {\n  overflow: visible;\n  flex: 0 0 80px;\n}\n:host .mat-column-id {\n  flex: 1 1 200px;\n}\n:host .mat-column-group {\n  flex: 1 1 200px;\n}\n:host .mat-column-value {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-1, :host mat-cell.mat-column-lang-1 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-2, :host mat-cell.mat-column-lang-2 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-3, :host mat-cell.mat-column-lang-3 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-4, :host mat-cell.mat-column-lang-4 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-5, :host mat-cell.mat-column-lang-5 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-6, :host mat-cell.mat-column-lang-6 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-7, :host mat-cell.mat-column-lang-7 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-8, :host mat-cell.mat-column-lang-8 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-9, :host mat-cell.mat-column-lang-9 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-10, :host mat-cell.mat-column-lang-10 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-11, :host mat-cell.mat-column-lang-11 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-12, :host mat-cell.mat-column-lang-12 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-13, :host mat-cell.mat-column-lang-13 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-14, :host mat-cell.mat-column-lang-14 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-15, :host mat-cell.mat-column-lang-15 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-16, :host mat-cell.mat-column-lang-16 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-17, :host mat-cell.mat-column-lang-17 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-18, :host mat-cell.mat-column-lang-18 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-19, :host mat-cell.mat-column-lang-19 {\n  flex: 1 1 200px;\n}\n:host mat-header-cell.mat-column-lang-20, :host mat-cell.mat-column-lang-20 {\n  flex: 1 1 200px;\n}\n:host .mat-column-remove {\n  flex: 1 1 60px;\n  padding-right: 0px !important;\n}\n:host .mat-cell {\n  font-size: 13px;\n  overflow: visible;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n:host .mat-header-cell {\n  font-size: 15px;\n  overflow: visible;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
